import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material';

import { getModuleChipColors } from '@/shared/lib/hooks/useModuleChipColors';

import { ChipsWrapper, UserTypeChip } from './Comment.styles';
import { PlatformChipInfo } from './commentUtils';

interface AuthorChipsProps {
  platformChipInfo: PlatformChipInfo | null;
  authorRole: string | null;
}

const AuthorChips: FC<AuthorChipsProps> = ({ platformChipInfo, authorRole }) => {
  const { t } = useTranslation();
  const { palette } = useTheme();

  if (!platformChipInfo && !authorRole) return null;

  const platformColors =
    platformChipInfo && getModuleChipColors(palette, platformChipInfo.userType);

  return (
    <ChipsWrapper>
      {platformChipInfo && platformColors && (
        <UserTypeChip bgColor={platformColors.bg} textColor={platformColors.text}>
          {t(platformChipInfo.label)}
        </UserTypeChip>
      )}
      {authorRole && (
        <UserTypeChip bgColor={palette.grey[500]} textColor={palette.common.white}>
          {authorRole}
        </UserTypeChip>
      )}
    </ChipsWrapper>
  );
};

export default AuthorChips;
